import * as React from "react";
import { observer } from "mobx-react-lite";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { Mk8sDraftMobx } from "../../../../mst/stores/mk8s.draft";
import { ProviderOblivusUnmanagedNodePool } from "./unmanagedNodePool";
import { mk8sMobx } from "../../../../mst/kinds/mk8s/mk8s";

type RouteParams = "index";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const ProviderOblivusUnmanagedNodePoolContainerRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  const { pathname } = useLocation();

  const { index: indexStr } = useParams<RouteParams>();
  const index = Number(indexStr);

  const o = mk8sDraft.provider_oblivus;
  const np = o.unmanagedNodePools.find((np) => np.index === index);

  if (!np) {
    return <Navigate to={`${pathname.split("/-unmanaged-node-pools")[0]}/-unmanaged-node-pools`} />;
  }

  return (
    <ProviderOblivusUnmanagedNodePool
      mk8s={mk8s}
      mk8sDraft={mk8sDraft}
      oblivus={o}
      nodePool={np}
      index={index}
    />
  );
};

export const ProviderOblivusUnmanagedNodePoolContainer = observer(ProviderOblivusUnmanagedNodePoolContainerRaw);
